import { Link } from "@quintype/components";
import get from "lodash/get";
import { array, object, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";
import WideStoryCard from "../../molecules/WideStoryCard";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import Organism1 from "./Organism1";
import Organism2 from "./Organism2";

import { getCollectionName, getSlug } from "../../utils/utils";

import "./fourCollection12Stories1Ad.m.css";

const FourCollection12Stories1Ad = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const [isTab, setIsTab] = useState(false);
  const [mostCommentedStories, setMostCommentedStories] = useState([]);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const adSlotId = get(collection, ["associated-metadata", "ad_slot_id"], "default_ad_slot");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const storiesToLoadInFirstCollection = 6;

  const storiesToLoadInRemainingCollections = get(
    collection,
    ["associated-metadata", "number_of_stories_inside_collection_to_show"],
    5
  );

  const subCollections = collection.items
    .filter((collectionObj) => collectionObj.type === "collection" && collectionObj.items && collectionObj.items.length)
    .slice(0, 4);

  const columnCollections = subCollections.slice(1, 4);
  const fourthCollection = subCollections.length > 0 ? subCollections[0] : null;
  const storyList =
    fourthCollection && fourthCollection.items && fourthCollection.items.length > 0
      ? fourthCollection.items.filter((item) => item.type === "story").slice(0, storiesToLoadInFirstCollection)
      : null;

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showSubCollectionName = get(fourthCollection, ["associated-metadata", "show_collection_name_website"], null);

  const fourthCollectionNavigateTo = get(fourthCollection, ["associated-metadata", "navigate_to"], "");
  const fourthCollectionNavigateToTitle = get(fourthCollection, ["associated-metadata", "navigate_to_title"], "");

  const fourthCollectionName = getCollectionName(fourthCollection, fourthCollectionNavigateToTitle);
  const fourthCollectionSlug = getSlug(fourthCollection, sections, domainSlug, fourthCollectionNavigateTo);

  const mostCommentedData = get(mostCommentedStories, ["pages", "data"], null);
  const mostCommentedStoriesList =
    (mostCommentedData &&
      mostCommentedData.length > 0 &&
      mostCommentedData.filter((item) => item.attributes.comments_count > 0)) ||
    [];

  const mostCommentedStoryObjects =
    (mostCommentedStoriesList &&
      mostCommentedStoriesList.length > 0 &&
      mostCommentedStoriesList
        .map((item) => ({
          story: {
            headline: item.attributes.headline,
            "hero-image-s3-key": item.attributes.hero_image_url,
            url: item.attributes.url,
          },
        }))
        .filter(({ story }) => story.headline && story.headline)) ||
    [];

  const mostCommentedTitle = get(collection, ["associated-metadata", "most_commented_title"], "");
  const mostCommentedPosition = get(collection, ["associated-metadata", "most_commented_position"], null);

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
      setIsTab(!isTab);
    }
    if (mostCommentedPosition) {
      const getMostCommentedStories = async () => {
        const result = await fetch(
          `${publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.metypeHost}/api/v1/accounts/${
            publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.metypeAccountId
          }/all_pages?time_unit=day&time_unit_magnitude=${
            publisherAttributes.metypeConfig && publisherAttributes.metypeConfig.most_commented_magnitude
          }&sort_by=comments_count&per_page=6&domains=${window.location.origin}`
        );
        setMostCommentedStories(await result.json());
      };

      getMostCommentedStories();
    }
  }, []);

  const getStories = (initialSliceCount, endSliceCount) => {
    if (
      mostCommentedPosition === 1 &&
      mostCommentedStoryObjects &&
      mostCommentedStoryObjects.length > initialSliceCount
    ) {
      return mostCommentedStoryObjects.slice(initialSliceCount, endSliceCount);
    } else if (mostCommentedStoryObjects !== 1 && storyList.length > initialSliceCount) {
      return storyList.slice(initialSliceCount, endSliceCount);
    } else return null;
  };

  return (
    <div styleName="base" className="four-collection-12stories-1ad">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionSlug={collectionSlug} collectionName={collectionName} />
      )}
      <div styleName={columnCollections.length > 0 ? "collection-container" : ""}>
        {columnCollections && columnCollections.length > 0 && (
          <Organism1
            subCollections={columnCollections}
            lang={publisherAttributes.lang}
            mostCommentedStoriesList={mostCommentedStoryObjects}
            mostCommentedTitle={mostCommentedTitle}
            mostCommentedPosition={mostCommentedPosition}
            storiesToLoadInRemainingCollections={storiesToLoadInRemainingCollections}
          />
        )}
        <div className="collection-wrapper">
          {showSubCollectionName && (
            <Link
              aria-label={mostCommentedPosition !== 1 ? fourthCollectionName : mostCommentedTitle}
              href={fourthCollectionSlug}
            >
              <h2 styleName="first-collection-name">
                {mostCommentedPosition !== 1 ? fourthCollectionName : mostCommentedTitle}
              </h2>
            </Link>
          )}
          <div styleName="collection-story-wrapper">
            <div>
              <div styleName="big-story" className="big-story-cards">
                {getStories(0, 1) && (
                  <WideStoryCard
                    story={getStories(0, 1)[0].story}
                    widths={global.deviceWidth < 876 ? [350] : [620]}
                    aspectRatio={[3, 2]}
                    imageType="image3x2"
                    isCommentedStory={mostCommentedPosition === 1}
                    excerptShow={false}
                  />
                )}
              </div>
              {getStories(1, 3) && (
                <div styleName="medium-story" className="medium-story-cards">
                  <Organism2 storyList={getStories(1, 3)} isCommentedStory={mostCommentedPosition === 1} />
                </div>
              )}
            </div>
            <div styleName="right-column">
              <div styleName={isTab ? "ad-slot-728x90" : "ad-slot-300x250"}>
                <DfpAd
                  adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R2" : "Home_336x280_R2"}
                  collectionSlug={collectionSlug}
                  layoutName="FourCollection12Stories1Ad"
                  slotId={adSlotId}
                />
              </div>
              {getStories(3, 6) && (
                <div styleName={isTab ? "tab-small-story" : "small-story"} className="small-story-cards">
                  {getStories(3, 6).map(({ story }, index) => (
                    <LeftImageRightNews key={index} story={story} />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FourCollection12Stories1Ad.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

FourCollection12Stories1Ad.nestedCollectionLimit = [6, 5, 5, 5];

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(FourCollection12Stories1Ad);
